export enum I18nSupported {
  ENGLISH = 'en-GB',
  ITALIAN = 'it-IT',
  GERMAN = 'de-DE',
  SPANISH = 'es-ES'
}
